import TipoOrdemServicoService from "@/services/TipoOrdemServicoService";

export const tipoOrdemServico = {
  namespaced: true,
  state: {
    tipoOrdemServico: {},
  },
  actions: {
    getTipoOrdemServico({ commit }, payload) {
      return TipoOrdemServicoService.GetTipoOrdemServico(payload).then(
        (tipoOrdemServico) => {
          return Promise.resolve(tipoOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTipoOrdemServico({ commit }, payload) {
      return TipoOrdemServicoService.PostTipoOrdemServico(payload).then(
        (tipoOrdemServico) => {
          return Promise.resolve(tipoOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTipoOrdemServico({ commit }, payload) {
      return TipoOrdemServicoService.PutTipoOrdemServico(payload).then(
        (tipoOrdemServico) => {
          return Promise.resolve(tipoOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTipoOrdemServico({ commit }, payload) {
      return TipoOrdemServicoService.DeleteTipoOrdemServico(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTipoOrdemServicoOData({ commit }, payload) {
      return TipoOrdemServicoService.GetTipoOrdemServicoOData(payload).then(
        (tipoOrdemServico) => {
          return Promise.resolve(tipoOrdemServico);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default tipoOrdemServico;
